<template>
    <vue100vh style="position: fixed; width: -webkit-fill-available;">
      <div style="height: calc(100vh - 64px); overflow-x: hidden; overflow-y: scroll;">
        <v-toolbar style="background-color: white !important;">
          <v-btn icon @click="toPage('/setting')">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-toolbar-title>{{$t('HeaderMenubar.languages')}}</v-toolbar-title>
        </v-toolbar>
        <div style="text-align: left;">
          <v-list dense>
            <v-list-item  @click="changeLan('th')">
              <v-list-item-avatar>
                <img :src="`${publicPath}/assets/flag/thailand.svg`" style="height: 35px;" />
              </v-list-item-avatar>
    
              <v-list-item-content>
                <v-list-item-title class="pl-2">ไทย</v-list-item-title>
              </v-list-item-content>
    
              <v-list-item-action v-if="language === 'th'">
                <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-list-item @click="changeLan('en')">
              <v-list-item-avatar>
                <img :src="`${publicPath}/assets/flag/united-kingdom.svg`" style="height: 35px;" />
              </v-list-item-avatar>
    
              <v-list-item-content>
                <v-list-item-title class="pl-2">ENG</v-list-item-title>
              </v-list-item-content>
    
              <v-list-item-action v-if="language === 'en'">
                <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
              </v-list-item-action>
            </v-list-item>
            <!-- <v-list-item @click="changeLan('cn')">
              <v-list-item-avatar>
                <img src='/static/flag/china.png' style="height: 35px;" />
              </v-list-item-avatar>
    
              <v-list-item-content>
                <v-list-item-title class="pl-2">中文</v-list-item-title>
              </v-list-item-content>
    
              <v-list-item-action v-if="language === 'cn'">
                <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
              </v-list-item-action>
            </v-list-item> -->
          </v-list>
        </div>
      </div>
    </vue100vh>
    </template>
    <script type="text/javascript">
    import vue100vh from 'vue-100vh'
    export default {
      data: () => ({
        language: '',
        publicPath: process.env.VUE_APP_BASE_PATH,
      }),
      methods: {
        toPage(data) {
          this.$router.push(data)
        },
        changeLan(lang) {
          this.$i18n.locale = lang
          this.$cookie.set('language', lang)
          this.language = lang
          // this.changeLangMenu()
        },
      },
      components: {
        vue100vh
      },
      created() {
        this.$i18n.locale = (this.$cookie.get('language')) ? this.$cookie.get('language') : 'th'
        this.language = (this.$cookie.get('language')) ? this.$cookie.get('language') : 'th'
        // console.log(this.$cookie.get('language'))
      }
    }
    </script>
    <style type="text/css" scoped>
    >>>.v-toolbar {
      /* box-shadow: none; */
      box-shadow: 0 2px 0px -1px hsla(0, 0%, 100%, .12), 0 0px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12) !important;
    }
    
    .CSChatThai {
      font-family: 'CS ChatThaiUI' !important;
      word-wrap: break-word;
    }
    
    a:link {
      text-decoration: none;
      color: black !important;
    }
    
    a:visited {
      color: white !important;
      text-decoration: none;
    }
    
    a:hover {
      color: #1e88e5 !important;
      text-decoration: none;
    }
    
    a:active {
      color: black !important;
      text-decoration: none;
    }
    </style>
    